// Generated from build58 src/features/musicEdition/captureSize.ts; do not edit.
/** iOS SVG's renderer treats export dimensions as points; Android uses pixels. */
export function editionCaptureSize(format, platform, pixelRatio) {
  const scale =
    platform === 'ios' && Number.isFinite(pixelRatio) && pixelRatio > 0 ? pixelRatio : 1;
  return {
    width: Math.round(1080 / scale),
    height: Math.round((format === 'story' ? 1920 : 1509) / scale),
  };
}
